import React from 'react';
import AutoScopeStylesDecorator from '../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import ECargoLogoAndBlurbView from '../../Common/Components/ECargoLogoAndBlurbView.jsx';
import RecoverAccountActions from '../Actions/RecoverAccountActions'
import ShowSpinnerOnActionInProgress from '../../../Common/Components/ShowSpinnerOnActionInProgress.jsx';
import applyDecoratorsDoNotUseInNewCode from '../../../Common/Utilities/Decorators/ApplyDecorators';
import { Link } from "react-router-dom-v5-compat";

class RecoverAccountPageView extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            userLogin: ''
        }
    }

    handleUserLoginChange = (event) => {
        this.setState({ userLogin: event.target.value });
    }

    render() {
        return (
            <ECargoLogoAndBlurbView>
                <ShowSpinnerOnActionInProgress>{
                    <div className="recover">
                        <form>
                            <div className="details">
                                <div className="instruction">
                                    Enter your eCargo login. A link will be emailed to you which will let you reset your password.
                                </div>

                                <label>Login</label>
                                <input id="login" type="text" value={ this.state.userLogin } onChange={ this.handleUserLoginChange } />
                            </div>
                            <div className="links">
                                <button
                                    id="sendLink"
                                    type="submit"
                                    className="primary button"
                                    onClick={ this.sendAccountRecoveryEmail } >
                                    Send link
                                </button>
                                <Link id="logInPageLink" to="/App/Auths/LogIn">Return to login</Link>
                            </div>
                        </form>
                    </div>
                }</ShowSpinnerOnActionInProgress>
            </ECargoLogoAndBlurbView>
        );
    }

    sendAccountRecoveryEmail = (event) => {
        event.preventDefault();
        RecoverAccountActions.sendAccountRecoveryEmail(this.state.userLogin);
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStylesDecorator);

export default withDecorators(RecoverAccountPageView);
